import { Button, Modal } from 'rsuite';
import { t } from 'i18next';
interface IProps {
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  logOutUrl: string;
  logInUrl: string;
}

export const ModalAlert = ({ open, setOpen, logOutUrl, logInUrl }: IProps) => {
  const handleLogoff = () => {
    window.open(logOutUrl, '_self');
  };
  const handleRefreshSession = () => {
    window.open(logInUrl, '_self');
  };

  return (
    <div className="session-expired-alert">
      <Modal
        className="session-modal"
        backdrop="static"
        role="alertdialog"
        open={open}
        onClose={() => {
          setOpen(false);
        }}
        size="md"
      >
        <Modal.Header>
          <Modal.Title>{t('common.sessionTimeoutDialog.title')}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {t('common.sessionTimeoutDialog.timeoutMessage')}
        </Modal.Body>
        <Modal.Footer>
          <Button
            appearance="ghost"
            onClick={handleLogoff}
            className="btn-logoff"
          >
            {t('common.sessionTimeoutDialog.logoffBtn')}
          </Button>
          <Button
            appearance="ghost"
            onClick={handleRefreshSession}
            className="btn-refresh"
          >
            {t('common.sessionTimeoutDialog.refreshBtn')}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};
